import { render, staticRenderFns } from "./LocalizationsList.vue?vue&type=template&id=3ee619c9&scoped=true&"
import script from "./LocalizationsList.vue?vue&type=script&lang=js&"
export * from "./LocalizationsList.vue?vue&type=script&lang=js&"
import style0 from "./LocalizationsList.vue?vue&type=style&index=0&id=3ee619c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee619c9",
  null
  
)

export default component.exports